import React from 'react';
import { getPrivacyPolicy } from '../../lib/Organization';
import { useI18n } from '../../lib/hook/useI18n';
import Link from '../Link';

const PrivacyPolicy: React.FC = () => {
  const { t } = useI18n();

  return (
    <Link
      href={getPrivacyPolicy()}
      text={t('privacy_policy')}
      variant="caption"
    />
  );
};

export default PrivacyPolicy;
